/* Fixes iOS Safari back button */
(function () {
    window.onpageshow = function(event) {
        if (event.persisted) {
            window.location.reload();
        }
    };
})();

var Theme = Theme || {};

Theme.Cart = {
    element: null,
    headerIcon: null,
    closeIcon: null,
    isVisibile: false,
    init: function () {
        this.element = document.querySelector('#cart');
        this.headerIcon = document.querySelector('#header__cart');
        this.headerIcon.addEventListener('click', () => {
            this.toggle();
        });
        
        this.closeIcon = document.querySelector('#cart__close');
        this.closeIcon.addEventListener('click', () => {
            this.toggle();
        });
        
        this.addItemListeners();
        
        // Closes sidebar when clicking outside of it.
        document.body.addEventListener('click', function(event) {
            if (Theme.Cart.isVisibile) {
                let isChildOfCart = false;
                let currentParent = event.target;
                while (currentParent.parentElement) {
                    if (currentParent.id === 'cart') {
                        isChildOfCart = true;
                        break;
                    } else {
                        currentParent = currentParent.parentElement;
                    }
                }

                if (!isChildOfCart && 
                    event.target.parentElement.id !== 'header__cart' && 
                    event.target.id !== 'header__cart') {
                    Theme.Cart.toggle();
                }
            }
        });
    },
    open: function() {
        this.element.classList.add('cart--open');
        document.body.classList.add('body--locked');
    },
    close: function() {
        document.body.classList.remove('body--locked');
        this.element.classList.remove('cart--open') 
    },
    toggle: function () {
        this.isVisibile ? this.close() : this.open();
        this.isVisibile = !this.isVisibile;
    },
    add: function (variant, quantity) {
        return new Promise((resolve, reject) => {
            ShopifyAPI.Cart.add(variant, quantity).then((response) => {
                Theme.Cart.update().then(() => {
                    !Theme.Cart.isVisibile && Theme.Cart.toggle();
                    resolve();
                });
            }).catch(error => {
                if (error == 422) {
                    reject();
                }
            });
        });
    },
    update: function () {
        return new Promise((resolve, reject) => {
            fetch('/?sections=cart-sidebar', {
                method: 'GET'
            })
            .then(response => response.json())
            .then(data=> {
                let newSidebar = document.createElement('html');
                newSidebar.innerHTML = `<body>${data['cart-sidebar']}</body>`;
                newSidebar = newSidebar.querySelector('#shopify-section-cart-sidebar');
                
                let totalQuantity = 0;
                newSidebar.querySelectorAll('.cart__item input')?.forEach((element, index, array) => totalQuantity += parseInt(element.value));
                this.headerIcon.innerHTML = `Cart (${totalQuantity})`;
                
                this.element.querySelector('#cart__header').innerHTML = newSidebar.querySelector('#cart__header').innerHTML;
                
                if (document.querySelector('#cart__items') && newSidebar.querySelector('#cart__items')) {
                    this.element.querySelector('form').replaceChild(newSidebar.querySelector('#cart__items'), this.element.querySelector('#cart__items'));
                    this.addItemListeners();
                    this.element.querySelector('#cart__total').innerHTML = newSidebar.querySelector('#cart__total').innerHTML;
                } else if (document.querySelector('#cart__items') && newSidebar.querySelector('#cart__items') == null) {
                    this.element.querySelector('form').remove();
                    this.element.querySelector('#cart__content').dataset.count = 0;
                } else if (this.element.querySelector('form') == null && newSidebar.querySelector('form')) {
                    this.element.querySelector('#cart__content').dataset.count = newSidebar.querySelector('#cart__content').dataset.count;
                    this.element.querySelector('#cart__content').appendChild(newSidebar.querySelector('form'));
                    this.addItemListeners();
                }
                
                this.element.classList.remove('cart--loading');
                resolve();
            });
        });
    },
    addItemListeners: function () {
        document.querySelectorAll('#cart__items > .cart__item').forEach((cartItem, index, array) => {
            // Add delete cart item event listener
            /*cartItem.querySelector('.cart__item-remove').addEventListener('click', function(event) {
                event.preventDefault();
                Theme.Cart.element.classList.add('cart--loading');
                
                ShopifyAPI.Cart.update(parseInt(cartItem.dataset.itemId), 0)
                .then((response) => {
                    Theme.Cart.update().then(() => {
                        Theme.Cart.element.classList.remove('cart--loading');
                    });
                });
            });*/
            
            // Quantity Increase Listener
            cartItem.querySelector('.cart__item-quantity-increase').addEventListener('click', function(event) {
                event.preventDefault();
                Theme.Cart.element.classList.add('cart--loading');
                
                let quantityInputValue = this.parentElement.querySelector('input').value;
                
                ShopifyAPI.Cart.update(parseInt(cartItem.dataset.itemId), parseInt(quantityInputValue) + 1)
                .then((response) => {
                    Theme.Cart.update().then(() => {
                        Theme.Cart.element.classList.remove('cart--loading');
                    });
                }).catch((error)  => {
                    // TODO handle this, 422
                    Theme.Cart.element.classList.remove('cart--loading');
                });
            });
            
            // Quantity Decrease Listener
            cartItem.querySelector('.cart__item-quantity-decrease').addEventListener('click', function(event) {
                event.preventDefault();
                Theme.Cart.element.classList.add('cart--loading');
                
                let quantityInputValue = this.parentElement.querySelector('input').value;
                
                ShopifyAPI.Cart.update(parseInt(cartItem.dataset.itemId), parseInt(quantityInputValue) - 1)
                .then((response) => {
                    Theme.Cart.update().then(() => {
                        Theme.Cart.element.classList.remove('cart--loading');
                    });
                });
            });
        });
    }
}

document.addEventListener('readystatechange', () => {
    if (document.readyState == 'interactive') {
        Theme.Cart.init();
    } 
});
